import { useStripeOrgs } from '../../api/admin-stripe'
import { OrgSubscriptionItemsPanel } from './OrgSubscriptionItemsPanel'
import { PricingConfigPanel } from './PricingConfigPanel'
import { PricingStrategyNotePanel } from './PricingStrategyNotePanel'
import { StripeInventoryTable } from './StripeInventoryTable'

/**
 * "Stripe" tab — pricing config, Stripe inventory, per-org subscription
 * items, and the strategy reminder.
 *
 * The org list at the top of the panel doubles as the data source for
 * OrgSubscriptionItemsPanel's picker. Loaded once at the tab level so the
 * picker doesn't refetch every time the operator drills into a different
 * org's items list.
 */
export function AdminBillingStripeTab() {
  const orgs = useStripeOrgs()
  const orgRows =
    orgs.data?.orgs.map((o) => ({
      org_id: o.id,
      name: o.name,
      status: o.stripe_subscription_status,
      has_subscription: !!o.stripe_subscription_id,
    })) ?? []

  return (
    <div className="space-y-6">
      <PricingConfigPanel />
      <PricingStrategyNotePanel />
      <StripeInventoryTable />
      {orgs.isLoading ? (
        <div className="text-sm text-text-secondary">Loading orgs…</div>
      ) : orgRows.length === 0 ? (
        <div className="rounded border border-border bg-surface p-4 text-sm text-text-secondary">
          No orgs found.
        </div>
      ) : (
        <OrgSubscriptionItemsPanel orgs={orgRows} />
      )}
    </div>
  )
}
